import { schema } from 'normalizr'

export const postSchema = new schema.Entity('posts')
export const imageSchema = new schema.Entity('images')

const options = {
    idAttribute: 'slug',
}

export const categorySchema = new schema.Entity(
    'categories',
    {
        background: imageSchema,
    },
    options
)

export const newsSchema = new schema.Entity(
    'news',
    {
        image: imageSchema,
        background: imageSchema,
    },
    options
)

export const onStreetSchema = new schema.Entity(
    'onStreetLocations',
    {
        background: imageSchema,
    },
    options
)

export const serviceSchema = new schema.Entity('services', {
    image: imageSchema,
})

export const promotionSchema = new schema.Entity('promotions')

export const ticketsSchema = new schema.Entity('tickets')

export const contentSchema = new schema.Entity('contentPages', {
    background: imageSchema,
})

export const schemaFromKind = kind =>
    ({
        news: newsSchema,
        categories: categorySchema,
        locations: onStreetSchema,
        content: contentSchema,
        services: serviceSchema,
        promotions: promotionSchema,
        tickets: ticketsSchema,
    }[kind] || postSchema) // prettier-ignore
